// Till payment statuses (Phase 11), shared by the individual's list and the
// business portal.
import type { Schemas } from "../../api/client";

export const TILL_STATUS_COLOUR: Record<Schemas["TillPayment"]["status"], string> = {
  pending: "yellow",
  paid: "green",
  not_paid: "gray",
};
